<template>
  <div id="page-intro" v-on:mousemove="mouseMove" v-on:click="closeIntro">
    <div class="scroll-wrapper">
      <div
        class="row align-middle xsmall-align-top align-center medium-collapse"
      >
        <div class="xxlarge-8 medium-12 columns">
          <div class="img-wrapper">
            <img src="/static/imgs/intro-image.jpg" />
          </div>
          <h2>
            <span>As</span> <span>exposições</span> <span>do</span>
            <span>Colégio</span> <span>das Artes</span>
            <span>da Universidade de Coimbra</span>
            <span>tomam diferentes</span> <span>configurações num</span>
            <span>espaço amplo.</span> <span>8 salas que ocupam</span>
            <span>uma das alas</span> <span>do edifício são</span>
            <span>espaço laboratorial</span>
            <span>de diferentes geometrias.</span> <span>A arte encontra</span>
            <span>um lugar singular</span> <span>no meio académico,</span>
            <span>onde a relação</span> <span>entre a arte</span>
            <span>e a prática conceptual</span> <span>tem, neste</span>
            <span>Colégio e nestas salas,</span>
            <span>um campo exploratório</span> <span>que se amplia</span>
            <span>numa intensa</span> <span>atividade editorial.</span>
          </h2>

          <h3 class="intro-subtitle">
            (Espaço integrado da Rede Portuguesa de Arte Contemporânea)
          </h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TweenMax } from "greensock";
import { debounce } from "debounce";

import eventBus from "../../eventBus";

export default {
  name: "page-intro",
  data() {
    return {
      mouseX: 0,
      mouseY: 0,
      windowW: window.innerWidth,
      windowH: window.innerHeight,
      introTitle: []
    };
  },
  mounted() {
    this.$globalFunctions.disableBodyScroll(true, ".scroll-wrapper");

    window.addEventListener("resize", debounce(this.handleResize, 500));

    this.loop();
    this.introTitle = document.getElementsByTagName("span");
    var array = [];

    for (var i = 0; i < document.getElementsByTagName("span").length; i++) {
      array.push(i);
    }

    array.sort(() => Math.random() - 0.5);

    for (var i = 0; i < array.length; i++) {
      TweenMax.set(document.getElementsByTagName("span")[array[i]], {
        className: "+=active",
        delay: i * 0.1
      });
      TweenMax.to(document.getElementsByTagName("span")[array[i]], 2, {
        opacity: 1,
        delay: i * 0.05,
        ease: Expo.easeInOut
      });
    }

    TweenMax.to(".img-wrapper", 1, {
      opacity: 1,
      delay: 1.5,
      ease: Expo.easeInOut
    });

    TweenMax.set(".intro-subtitle", {
      className: "+=active",
      delay: 3
    });
  },
  methods: {
    closeIntro: function() {
      TweenMax.to("#page-intro", 0.5, { autoAlpha: 0 });
      this.$globalFunctions.disableBodyScroll(false);
      eventBus.$emit("intro-out");
    },
    mouseMove: function(event) {
      this.mouseX = this.windowW / 2 - event.screenX;
      this.mouseY = this.windowH / 2 - event.screenY;
    },
    loop: function() {
      requestAnimationFrame(this.loop);

      TweenMax.to("#page-intro img", 5, {
        x: this.mouseX * 0.01,
        y: this.mouseY * 0.01,
        ease: Expo.easeOut
      });

      TweenMax.to("#page-intro h2", 5, {
        x: this.mouseX * 0.02,
        y: this.mouseY * 0.02,
        ease: Expo.easeOut
      });
    },
    shuffle: function(a) {
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    },
    handleResize: function() {
      console.log("resize event");
      this.$globalFunctions.fixVhUnits();
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  }
};
</script>
<!-- styling for the component -->
<style lang="scss">
#page-intro {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  // min-height: 650px;
  background-color: rgba(0, 0, 0, 0.95);

  z-index: 100;

  cursor: pointer;

  .row {
    height: 100%;
  }

  .scroll-wrapper {
    height: 100%;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }

  .img-wrapper {
    width: 100px;
    margin: 0 auto;
    z-index: 1;

    opacity: 0;
    //mix-blend-mode: exclusion;

    cursor: pointer;
  }
  h2 {
    position: relative;
    margin-top: 50px;

    color: white;
    text-align: justify;
    @include responsive-font-size(35px);

    span {
      opacity: 0;
      filter: blur(5px);

      -webkit-transition: filter 1s ease-in-out;
      transition: filter 1s ease-in-out;

      &.active {
        filter: blur(0px);
      }
    }
  }

  h3 {
    margin-top: 40px;
    color: white;
    text-align: center;

    @include responsive-font-size(20px);
    filter: blur(5px);

    opacity: 0;
    transform: translateY(20px);
    transition: transform 1s ease-in-out, opacity 1s ease-in-out,
      filter 1s ease-in-out;

    &.active {
      opacity: 1;
      transform: translateY(0px);
      filter: blur(0px);
    }
  }
}

@include max-screen($medium) {
  #page-intro {
    padding: 0 60px;
  }
}

@include max-screen($small) {
  #page-intro {
    padding: 0 20px;
  }
}

@include max-screen($xsmall) {
  #page-intro {
    .row {
      height: auto;
    }
    .scroll-wrapper {
      padding: 50px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/blocks/pageIntro.vue